import { takoUUID } from '../utils/takoUUID';
import {
    setHxAttrs,
    createHxTarget,
    createHxIndicator,
} from '../utils/htmxHelper';

/**
 * Creates an htmx-powered modal.
 * @param modalButton The button that triggers the modal.
 */
export const createHtmxModal = (modalButton: HTMLElement): void => {
    const dataModalTarget =
        modalButton.getAttribute('data-modal-target') || takoUUID('modal');
    modalButton.setAttribute('data-modal-target', dataModalTarget);

    const modalId = dataModalTarget.replace('#', '');
    const hxModal = document.querySelector(`#${modalId}`);
    const hxModalDialog = hxModal?.querySelector('.tako-modal__dialog');
    const hxModalHeader = hxModal?.querySelector('.tako-modal__title');

    // Add hx attributes to trigger element
    setHxAttrs(modalButton, 'modal');

    const modalDiv = (hxModal || document.createElement('div')) as HTMLElement;

    if (!hxModal) {
        modalDiv.setAttribute('id', modalId);
    }

    // Create modal with header (if title is provided), hx container, hx indicator
    modalDiv.classList.add('tako-modal');
    setModalAttr(modalButton, modalDiv);

    const modalDialog = (hxModalDialog ||
        document.createElement('div')) as HTMLElement;
    modalDialog.classList.add('tako-modal__dialog');
    setModalModifierClass(modalButton, modalDialog);

    const modalHTMXWrapper = document.createElement('div');
    const modalHTMXContent = createHxTarget(modalButton);
    const hxIndicator = createHxIndicator(modalButton, 'md');
    hxIndicator.style.minHeight = '5rem';

    modalHTMXWrapper.prepend(hxIndicator);
    modalHTMXWrapper.appendChild(modalHTMXContent);

    if (!hxModalHeader) {
        modalDialog.prepend(modalHTMXWrapper);
    } else {
        hxModalHeader.insertAdjacentElement('afterend', modalHTMXWrapper);
    }

    modalDiv.appendChild(modalDialog);

    if (!hxModal) {
        modalButton.insertAdjacentElement('afterend', modalDiv);
    }
};

/**
 * Sets attributes on the modal element.
 * @param modalButton The button that triggers the modal.
 * @param modal The modal element.
 */
const setModalAttr = (modalButton: HTMLElement, modal: HTMLElement): void => {
    const dataOverlay = modalButton.getAttribute('data-modal-overlay');

    // Add data attribute to modal if provided with trigger element
    if (dataOverlay === 'static') {
        modal.setAttribute('data-overlay', 'static');
    }
};

/**
 * Sets modifier classes on the modal dialog.
 * @param modalButton The button that triggers the modal.
 * @param modalDialog The modal dialog element.
 */
const setModalModifierClass = (
    modalButton: HTMLElement,
    modalDialog: HTMLElement,
): void => {
    const dataWidth = modalButton.getAttribute('data-modal-width');

    // Add modifier class to modal dialog if provided with trigger element
    if (dataWidth) {
        modalDialog.classList.add(`tako-modal__dialog--${dataWidth}`);
    }
};
